<div class="filters-shadow rounded-[10px] bg-white p-5">
  <div class="flex flex-col gap-6 pt-5">
    <div class="grid grid-cols-4 gap-6">
      <app-filter-input
        label="Search"
        i18n-label="@@departmentSearchLabel"
        placeholder="Search by department name"
        i18n-placeholder="@@departmentSearchPlaceholder"
        type="text"
        [(value)]="departmentName" />

      <div class="col-span-3"></div>
    </div>

    <div class="grid grid-cols-4 gap-6">
      <app-filter-date-component
        label="Created On From"
        i18n-label="@@departmentCreatedOnFromLabel"
        [value]="createdOnFrom()"
        (valueChange)="createdOnFrom.set($event)"
        [isInvalid]="createdDateInvalid()" />

      <app-filter-date-component
        label="Created On To"
        i18n-label="@@departmentCreatedOnToLabel"
        [value]="createdOnTo()"
        (valueChange)="createdOnTo.set($event)"
        [isInvalid]="createdDateInvalid()" />

      <app-filter-date-component
        label="Last Modified From"
        i18n-label="@@departmentLastModifiedFromLabel"
        [value]="lastModifiedOnFrom()"
        (valueChange)="lastModifiedOnFrom.set($event)"
        [isInvalid]="lastModifiedDateInvalid()" />

      <app-filter-date-component
        label="Last Modified To"
        i18n-label="@@departmentLastModifiedToLabel"
        [value]="lastModifiedOnTo()"
        (valueChange)="lastModifiedOnTo.set($event)"
        [isInvalid]="lastModifiedDateInvalid()" />
    </div>

    <div class="border_Color my-5 flex items-end justify-between border-t pt-5">
      <app-filter-sorting-component
        [orderBy]="filters().orderBy"
        (orderByChange)="onOrderByChange($event)"
        [orderDir]="filters().orderDir"
        [sortOptions]="sortOptions()"
        (toggleOrder)="onToggleSortOrder()" />

      <div class="flex gap-3">
        <app-submit-button type="secondary" (click)="onResetFilters()">
          <span i18n="@@departmentFilterClearButton">Clear</span>
        </app-submit-button>

        <app-submit-button type="primary" (click)="onApplyFilters()">
          <span i18n="@@departmentFilterApplyButton">Apply</span>
        </app-submit-button>
      </div>
    </div>
  </div>
</div>
